import React, { Component } from "react";
import Swal from "sweetalert2";
import {
  AiOutlinePlus,
  AiOutlineDelete,
  AiOutlineSearch,
  AiOutlineShoppingCart,
  AiOutlineCheck,
  AiOutlineClose
} from "react-icons/ai";
import "./PreSaleCatalog.css";

import { getInformationWithData } from "../services/CABE";
// Menu
import { Menu } from "../components/Menu/Menu";

class PreSaleCatalog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preSaleProducts: [],
      officialProducts: [],

      preSaleSearch: "",
      officialSearch: "",

      preSalePage: 1,
      officialPage: 1,

      preSaleTotalPages: 1,
      officialTotalPages: 1,

      pageSize: 20,

      loadingPreSale: false,
      loadingOfficial: false,
      savingProducts: false,
      deletingProductId: "",

      showOfficialModal: false,
      selectedOfficialProducts: []
    };
  }

  async componentDidMount() {
    await this.getPreSaleProducts(1, "");
  }

  normalizeText = function (value) {
    if (!value) return "";
    return value
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  };

  isAlreadyInPreSale = function (itemCode) {
    var preSaleProducts = this.state.preSaleProducts;

    return preSaleProducts.some(function (item) {
      return String(item.itemCode) === String(itemCode);
    });
  };

  isSelectedOfficialProduct = function (itemCode) {
    var selectedOfficialProducts = this.state.selectedOfficialProducts;

    return selectedOfficialProducts.some(function (item) {
      return String(item.itemCode) === String(itemCode);
    });
  };

  getPreSaleProducts = async function (page, search) {
    var currentPage = page || this.state.preSalePage;
    var currentSearch =
      typeof search === "string" ? search : this.state.preSaleSearch;

    this.setState({
      loadingPreSale: true
    });

    var data = {
      search: currentSearch,
      page: currentPage,
      limit: this.state.pageSize
    };

    try {
      const result = await getInformationWithData("/pre-order/items", data);

      if (result && result.status && result.status.code === 1) {
        this.setState({
          preSaleProducts: result.data || [],
          preSalePage:
            result.pagination && result.pagination.page
              ? result.pagination.page
              : currentPage,
          preSaleTotalPages:
            result.pagination && result.pagination.totalPages > 0
              ? result.pagination.totalPages
              : 1,
          loadingPreSale: false
        });
      } else {
        this.setState({
          preSaleProducts: [],
          preSalePage: currentPage,
          preSaleTotalPages: 1,
          loadingPreSale: false
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result &&
            result.status &&
            result.status.Description
              ? result.status.Description
              : "Could not load pre-sale products."
        });
      }
    } catch (error) {
      this.setState({
        preSaleProducts: [],
        preSalePage: currentPage,
        preSaleTotalPages: 1,
        loadingPreSale: false
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load pre-sale products."
      });
    }
  };

  deletePreSaleProductRequest = async function (product) {
    var data = {
      itemCode: product.itemCode
    };

    return await getInformationWithData("/pre-order/items/delete", data);
  };

  addProductsToPreSaleRequest = async function (products) {
    var responses = [];
    var i = 0;

    for (i = 0; i < products.length; i++) {
      var item = products[i];
      var data = {
        itemCode: item.itemCode
      };

      const req = await getInformationWithData("/pre-order/items/create", data);
      console.log(req);
      responses.push({
        itemCode: item.itemCode,
        response: req
      });
    }

    return responses;
  };

  getOfficialProducts = async function (page, search) {
    var currentPage = page || this.state.officialPage;
    var currentSearch =
      typeof search === "string" ? search : this.state.officialSearch;

    this.setState({
      loadingOfficial: true
    });

    var data = {
      search: currentSearch,
      page: currentPage,
      limit: this.state.pageSize
    };

    try {
      const result = await getInformationWithData("/official/items", data);

      if (result && result.status && result.status.code === 1) {
        this.setState({
          officialProducts: result.data || [],
          officialPage:
            result.pagination && result.pagination.page
              ? result.pagination.page
              : currentPage,
          officialTotalPages:
            result.pagination && result.pagination.totalPages > 0
              ? result.pagination.totalPages
              : 1,
          loadingOfficial: false
        });
      } else {
        this.setState({
          officialProducts: [],
          officialPage: currentPage,
          officialTotalPages: 1,
          loadingOfficial: false
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result &&
            result.status &&
            result.status.Description
              ? result.status.Description
              : "Could not load official products."
        });
      }
    } catch (error) {
      this.setState({
        officialProducts: [],
        officialPage: currentPage,
        officialTotalPages: 1,
        loadingOfficial: false
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load official products."
      });
    }
  };

  apiSearchPreSale = async function () {
    await this.getPreSaleProducts(1, this.state.preSaleSearch);
  };

  apiSearchOfficial = async function () {
    await this.getOfficialProducts(1, this.state.officialSearch);
  };

  handlePreSaleSearchChange = function (e) {
    this.setState({
      preSaleSearch: e.target.value
    });
  };

  handleOfficialSearchChange = function (e) {
    this.setState({
      officialSearch: e.target.value
    });
  };

  openOfficialModal = async function () {
    this.setState({
      showOfficialModal: true,
      selectedOfficialProducts: [],
      officialSearch: "",
      officialPage: 1,
      officialProducts: [],
      officialTotalPages: 1
    });

    await this.getOfficialProducts(1, "");
  };

  closeOfficialModal = function () {
    this.setState({
      showOfficialModal: false,
      selectedOfficialProducts: []
    });
  };

  toggleOfficialSelection = function (product) {
    if (this.isAlreadyInPreSale(product.itemCode)) {
      return;
    }

    var selectedOfficialProducts = this.state.selectedOfficialProducts.slice();

    var exists = selectedOfficialProducts.some(function (item) {
      return String(item.itemCode) === String(product.itemCode);
    });

    if (exists) {
      selectedOfficialProducts = selectedOfficialProducts.filter(function (item) {
        return String(item.itemCode) !== String(product.itemCode);
      });
    } else {
      selectedOfficialProducts.push(product);
    }

    this.setState({
      selectedOfficialProducts: selectedOfficialProducts
    });
  };

  addSelectedProductsToPreSale = async function () {
    var selectedOfficialProducts = this.state.selectedOfficialProducts;

    if (!selectedOfficialProducts.length) {
      Swal.fire({
        icon: "warning",
        title: "No products selected",
        text: "Please select at least one product."
      });
      return;
    }

    this.setState({
      savingProducts: true
    });

    try {
      const result = await this.addProductsToPreSaleRequest(selectedOfficialProducts);

      var successCount = result.filter(function (item) {
        return item.response && item.response.status && item.response.status.code === 1;
      }).length;

      if (successCount > 0) {
        this.setState({
          selectedOfficialProducts: [],
          showOfficialModal: false,
          savingProducts: false
        });

        await this.getPreSaleProducts(1, this.state.preSaleSearch);

        Swal.fire({
          icon: "success",
          title: "Done",
          text: successCount + " product(s) added to pre-sale catalog."
        });
      } else {
        this.setState({
          savingProducts: false
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Could not add products to pre-sale catalog."
        });
      }
    } catch (error) {
      this.setState({
        savingProducts: false
      });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not add products to pre-sale catalog."
      });
    }
  };

  deletePreSaleProduct = function (product) {
    var self = this;

    Swal.fire({
      icon: "warning",
      title: "Remove product?",
      text: "This product will be removed from the pre-sale catalog.",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "Cancel"
    }).then(async function (result) {
      if (!result.isConfirmed) return;

      self.setState({
        deletingProductId: String(product.itemCode)
      });

      try {
        const response = await self.deletePreSaleProductRequest(product);

        if (response && response.status && response.status.code === 1) {
          self.setState({
            deletingProductId: ""
          });

          await self.getPreSaleProducts(
            self.state.preSalePage,
            self.state.preSaleSearch
          );

          Swal.fire({
            icon: "success",
            title: "Removed",
            text:
              response.status.Description ||
              "The product was removed from pre-sale catalog."
          });
        } else {
          self.setState({
            deletingProductId: ""
          });

          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              response &&
              response.status &&
              response.status.Description
                ? response.status.Description
                : "Could not remove the product."
          });
        }
      } catch (error) {
        self.setState({
          deletingProductId: ""
        });

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Could not remove the product."
        });
      }
    });
  };

  changePreSalePage = async function (page) {
    if (page < 1 || page > this.state.preSaleTotalPages) return;
    await this.getPreSaleProducts(page, this.state.preSaleSearch);
  };

  changeOfficialPage = async function (page) {
    if (page < 1 || page > this.state.officialTotalPages) return;
    await this.getOfficialProducts(page, this.state.officialSearch);
  };

  renderPagination = function (currentPage, totalPages, onPageChange) {
    var buttons = [];
    var maxVisible = 10;
    var startPage = 1;
    var endPage = totalPages;

    if (totalPages > maxVisible) {
      startPage = currentPage - Math.floor(maxVisible / 2);
      endPage = currentPage + Math.floor(maxVisible / 2) - 1;

      if (startPage < 1) {
        startPage = 1;
        endPage = maxVisible;
      }

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxVisible + 1;
      }
    }

    if (startPage > 1) {
      buttons.push(
        <button
          key="page-1"
          className={
            currentPage === 1
              ? "ps-pagination__btn ps-pagination__btn--active"
              : "ps-pagination__btn"
          }
          onClick={function () {
            onPageChange(1);
          }}
        >
          1
        </button>
      );

      if (startPage > 2) {
        buttons.push(
          <span key="start-ellipsis" className="ps-pagination__dots">
            ...
          </span>
        );
      }
    }

    var i = 1;
    for (i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={"page-" + i}
          className={
            currentPage === i
              ? "ps-pagination__btn ps-pagination__btn--active"
              : "ps-pagination__btn"
          }
          onClick={function (page) {
            return function () {
              onPageChange(page);
            };
          }(i)}
        >
          {i}
        </button>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="end-ellipsis" className="ps-pagination__dots">
            ...
          </span>
        );
      }

      buttons.push(
        <button
          key={"page-" + totalPages}
          className={
            currentPage === totalPages
              ? "ps-pagination__btn ps-pagination__btn--active"
              : "ps-pagination__btn"
          }
          onClick={function () {
            onPageChange(totalPages);
          }}
        >
          {totalPages}
        </button>
      );
    }

    return (
      <div className="ps-pagination">
        <button
          className="ps-pagination__btn"
          onClick={function () {
            onPageChange(currentPage - 1);
          }}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {buttons}

        <button
          className="ps-pagination__btn"
          onClick={function () {
            onPageChange(currentPage + 1);
          }}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  render() {
    var visiblePreSaleProducts = this.state.preSaleProducts;
    var visibleOfficialProducts = this.state.officialProducts;

    return (
      <div>
        <Menu Refresh={this.state.Refresh} Father={this} />

        <div className="ps-page">
          <div className="ps-shell">
            <div className="ps-header">
              <div>
                <h1 className="ps-title">Pre-sale Product Catalog</h1>
                <p className="ps-subtitle">
                  Manage the products visible in your pre-sale catalog.
                </p>
              </div>

              <button
                className="ps-primary-btn"
                onClick={this.openOfficialModal.bind(this)}
              >
                <AiOutlinePlus />
                <span>Add Product</span>
              </button>
            </div>

            <div className="ps-toolbar">
              <div className="ps-search">
                <AiOutlineSearch className="ps-search__icon" />
                <input
                  type="text"
                  placeholder="Search pre-sale products..."
                  value={this.state.preSaleSearch}
                  onChange={this.handlePreSaleSearchChange.bind(this)}
                />
                <button onClick={this.apiSearchPreSale.bind(this)}>Search</button>
              </div>
            </div>

            {this.state.loadingPreSale ? (
              <div className="ps-empty">
                <h3>Loading products...</h3>
              </div>
            ) : visiblePreSaleProducts.length ? (
              <div className="ps-grid">
                {visiblePreSaleProducts.map(
                  function (product) {
                    var isDeleting =
                      this.state.deletingProductId === String(product.itemCode);

                    return (
                      <div className="ps-card" key={product.itemCode}>
                        <div className="ps-card__image-wrap">
                          {product.itemURLImage ? 
                            <img
                              src={product.itemURLImage}
                              alt={product.itemDesc}
                              className="ps-card__image"
                            />
                          : null}
                        </div>

                        <div className="ps-card__body">
                          <div className="ps-card__top">
                            <span className="ps-badge">{product.productLineDesc}</span>
                            <span className="ps-price">${product.averageUnitCost}</span>
                          </div>

                          <h3 className="ps-card__title">{product.itemDesc}</h3>
                          <p className="ps-card__code">{product.itemCode}</p>

                          <div className="ps-card__actions">
                            <button
                              className="ps-danger-btn"
                              onClick={function () {
                                this.deletePreSaleProduct(product);
                              }.bind(this)}
                              disabled={isDeleting}
                            >
                              <AiOutlineDelete />
                              <span>{isDeleting ? "Removing..." : "Remove"}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  }.bind(this)
                )}
              </div>
            ) : (
              <div className="ps-empty">
                <div className="ps-empty__icon">
                  <AiOutlineShoppingCart />
                </div>
                <h3>No products found</h3>
                <p>Try a different search or add products from the official catalog.</p>
              </div>
            )}

            {this.renderPagination(
              this.state.preSalePage,
              this.state.preSaleTotalPages,
              this.changePreSalePage.bind(this)
            )}

            {this.state.showOfficialModal ? (
              <div className="ps-modal">
                <div
                  className="ps-modal__backdrop"
                  onClick={this.closeOfficialModal.bind(this)}
                />

                <div className="ps-modal__panel">
                  <div className="ps-modal__header">
                    <div>
                      <p>Select one or more products to add to pre-sale catalog.</p>
                    </div>

                    <button
                      className="ps-icon-btn"
                      onClick={this.closeOfficialModal.bind(this)}
                    >
                      <AiOutlineClose />
                    </button>
                  </div>

                  <div className="ps-modal__toolbar">
                    <div className="ps-search">
                      <AiOutlineSearch className="ps-search__icon" />
                      <input
                        type="text"
                        placeholder="Search official products..."
                        value={this.state.officialSearch}
                        onChange={this.handleOfficialSearchChange.bind(this)}
                      />
                      <button onClick={this.apiSearchOfficial.bind(this)}>Search</button>
                    </div>

                    <div className="ps-selection-counter">
                      <AiOutlineCheck />
                      <span>{this.state.selectedOfficialProducts.length} selected</span>
                    </div>
                  </div>

                  <div className="ps-modal__content">
                    {this.state.loadingOfficial ? (
                      <div className="ps-empty">
                        <h3>Loading products...</h3>
                      </div>
                    ) : visibleOfficialProducts.length ? (
                      <div className="ps-grid ps-grid--modal">
                        {visibleOfficialProducts.map(
                          function (product, index) {
                            var alreadyInPreSale = this.isAlreadyInPreSale(product.itemCode);
                            var isSelected = this.isSelectedOfficialProduct(product.itemCode);

                            return (
                              <div
                                key={"official-" + (product.itemCode || index)}
                                className={
                                  alreadyInPreSale
                                    ? "ps-card ps-card--disabled"
                                    : isSelected
                                    ? "ps-card ps-card--selected"
                                    : "ps-card"
                                }
                              >
                                <div className="ps-card__image-wrap">
                                  {product.itemURLImage ? (
                                    <img
                                      src={product.itemURLImage}
                                      alt={product.itemDesc}
                                      className="ps-card__image"
                                    />
                                  ) : null}
                                </div>

                                <div className="ps-card__body">
                                  <div className="ps-card__top">
                                    <span className="ps-badge">{product.productLineDesc}</span>
                                    <span className="ps-price">${product.averageUnitCost}</span>
                                  </div>

                                  <h3 className="ps-card__title">{product.itemDesc}</h3>
                                  <p className="ps-card__code">{product.itemCode}</p>

                                  <div className="ps-card__actions">
                                    {alreadyInPreSale ? (
                                      <button className="ps-disabled-btn" disabled>
                                        Already in pre-sale
                                      </button>
                                    ) : isSelected ? (
                                      <button
                                        className="ps-primary-btn ps-primary-btn--small"
                                        onClick={function () {
                                          this.toggleOfficialSelection(product);
                                        }.bind(this)}
                                      >
                                        <AiOutlineCheck />
                                        <span>Selected</span>
                                      </button>
                                    ) : (
                                      <button
                                        className="ps-secondary-btn"
                                        onClick={function () {
                                          this.toggleOfficialSelection(product);
                                        }.bind(this)}
                                      >
                                        <AiOutlinePlus />
                                        <span>Add to pre-sale</span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          }.bind(this)
                        )}
                      </div>
                    ) : (
                      <div className="ps-empty">
                        <h3>No products found</h3>
                      </div>
                    )}
                  </div>

                  {this.renderPagination(
                    this.state.officialPage,
                    this.state.officialTotalPages,
                    this.changeOfficialPage.bind(this)
                  )}

                  <div className="ps-modal__footer">
                    <button
                      className="ps-secondary-btn"
                      onClick={this.closeOfficialModal.bind(this)}
                      disabled={this.state.savingProducts}
                    >
                      Cancel
                    </button>

                    <button
                      className="ps-primary-btn"
                      onClick={this.addSelectedProductsToPreSale.bind(this)}
                      disabled={this.state.savingProducts}
                    >
                      <AiOutlinePlus />
                      <span>
                        {this.state.savingProducts ? "Saving..." : "Add Selected"}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default PreSaleCatalog;